"use client";

import { CTPageView } from "@repo/analytics/data-layer-utils";
import { getPageType } from "@repo/shared-utils/common-utils";

if (typeof document !== "undefined") {
  const cleverTapPageView = getPageType("tag-7");
  if (cleverTapPageView) {
    CTPageView(cleverTapPageView);
  }
}

const EarlyPageViewStamp = () => {
  return null;
};

export default EarlyPageViewStamp;
